/**
 * "Finalista X edycji InCredibles" bar shown above the header for anonymous
 * visitors. Importable from both server (cookie read) and client (dismiss).
 */
export const INCREDIBLES_BAR_COOKIE = 'incredibles_x_bar_dismissed';

export const INCREDIBLES_BAR_COOKIE_VALUE = '1';

/** Bar height in px; the fixed header is offset by this while the bar is on screen */
export const INCREDIBLES_BAR_HEIGHT = 24;

export type IncrediblesBarVariant = 'citron' | 'black';
